import { BaseResource } from "./base.resource";

export class Config extends BaseResource {
  lastUpdateTime: Date;
  wasteTypeOptions: string[];
  physicalStateOptions: string[];
  manifestSortingOptions: string[];
  containerSortingOptions: string[];
  itemSortingOptions: string[];
  securedActionOptions: string[];
  testingMode: boolean;
  manifestPrintMargins: number[];

  constructor(options?: any) {
    super(options);
  }
}

export class OwnerChargeInfo {
  cai: string;
  chargeCode: string;
  labNumber: string;
}
